var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2"},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-heading"},[_vm._v("Example Component")]),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_vm._v("\n                    I'm an example component!\n                ")])])])])])
}]

export { render, staticRenderFns }